module.exports = __webpack_public_path__ + "img/fukuoka.41e62184.jpg";